import * as React from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Divider, Input, Select, Space, Button, Form, FormInstance } from 'antd';
import { getData } from '../../actions/apiCall';
import { postData } from '../../actions/developer';
import { useDispatch } from 'react-redux';
import { decryptData } from '../../actions/crypto';
const { Option } = Select;
const optionURL = '/public/list';
const { useState, useEffect } = React;

export interface DyanamicSelectProps {
    value?: string | string[];
    searchApi?: string;
    keyName?: string;
    multiple?: boolean;
    name?: string | any[];
    fieldKey?: string;
    addNew?: boolean;
    idKey?: string;
    more?: object;
    render?: (text) => void;
    isEncrypted?: boolean;
    onChange?: (value: string | string[], option: any) => void;
    rest?: any;
}

const DynamicSelect: React.FC<DyanamicSelectProps> = ({ searchApi = optionURL, keyName, multiple, addNew = true, idKey = undefined, onChange, more = {}, render = undefined, isEncrypted = true, value, rest }) => {
    const [optionValue, setOptionValue] = useState();
    const [optionsRes, setOptions] = useState([]);
    const [defaultValue, setDefaultValue] = useState<any>();
    const dispatch = useDispatch();

    useEffect(() => {
        getOptionData();
    }, []);

    useEffect(() => {
        if (value) {
            setDefaultValue(value);
        }
    }, [value]);

    const getOptionData = async (search = '') => {
        const resData = await dispatch(getData([searchApi, keyName].join('/'), { search: search, keys: 'name' }));
        if (resData && resData.code == 200) {
            let decryptedData = resData.data;
            if (isEncrypted) {
                decryptedData = decryptData(resData.data);
            }
            if (decryptedData.length > 0) {
                setOptions(decryptedData);
            } else {
                if (addNew) {
                    setOptionValue(capitalizeString(search));
                }
            }
        }
    };

    const capitalizeString = (str) => {
        return str
            .toLowerCase()
            .split(' ')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };

    const onSaveData = async () => {
        if (optionValue) {
            await dispatch(postData(searchApi, { name: capitalizeString(optionValue), optionType: keyName }));
        }
    };

    return (
        <Select
            showSearch={true}
            placeholder={'Type or select'}
            maxTagCount={1}
            maxTagTextLength={10}
            {...multiple ? { mode: 'tags' } : {}}
            onSearch={(e) => {
                getOptionData(e);
            }}
            value={defaultValue}
            onChange={(e, option) => {
                if (optionValue == e || (Array.isArray(e) && e.includes(optionValue))) {
                    onSaveData();
                }
                onChange?.(e, option);

            }}
            {...rest}
        >
            {addNew && optionValue && <Option value={optionValue} className="capitalize">{optionValue}</Option>}
            {optionsRes?.map((ele, index) => <Option key={index} className="capitalize" value={idKey ? ele[idKey] : ele.name}>{render ? render(ele) : ele.name}</Option>)}
        </Select>
    );
};
export default DynamicSelect;